import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { Store } from '@ngrx/store';
import { register } from 'swiper/element/bundle';
import { AppState } from 'src/app/core/store/app.state';
import { initAuth } from 'src/app/core/store/user/user.actions';
import { BuildOptimizerBugfixComponent } from './shell/build-optimizer-bugfix/build-optimizer-bugfix.component';
import { MenuComponent } from './shell/menu/menu.component';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    IonApp,
    IonRouterOutlet,
    MenuComponent,
    BuildOptimizerBugfixComponent,
  ],
})
export class AppComponent {
  constructor(private store: Store<AppState>) {
    this.store.dispatch(initAuth());

    // Register Swiper custom elements
    register();
  }
}
